import { type FC } from 'react';
import { useSelector } from 'react-redux';

import { developerRatingsSelector } from 'shared/selectors/specialPromosBlocks/developerRatingsSelector';

import { Ratings } from './Ratings';
import { trackShowRatingsBlock } from './internal/tracking/trackShowRatingsBlock';

export const RatingsContainer: FC = () => {
  const ratings = useSelector(developerRatingsSelector);

  if (!ratings?.ratings?.length) {
    return null;
  }

  return (
    <Ratings
      medals={ratings.medals}
      ratingSource={ratings.source}
      ratings={ratings.ratings}
      ratingsLabel={ratings.text}
      onView={() => trackShowRatingsBlock(ratings.ratings)}
    />
  );
};
